// extracted by mini-css-extract-plugin
export default {"ImageDots":"ImageDots_ImageDots__91W98","dot":"ImageDots_dot__lcLvp"};